import * as React from "react";
import { DDClinicalReasoning } from "fe-common/graphql/dao";
import { Dispatch } from "react";
import { QualifiedFeature } from "fe-common/graphql";
import { SupportingWeakeningWidget } from "../supportingWeakeningWidget";
import { useCalculateFindingPredictives } from "../../../util/FindingStrengthCalculator";

//region [[ Props ]]
export interface MiniDiseaseReasoningProps {
  crs: DDClinicalReasoning[];
  onFindingSelect?: Dispatch<QualifiedFeature>;
  cr: DDClinicalReasoning;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const MiniDiseaseReasoning = ({
  ...props
}: MiniDiseaseReasoningProps) => {
  const { onFindingSelect, crs, cr } = props;
  const getFindingsStrength = useCalculateFindingPredictives(crs);

  return (
    <SupportingWeakeningWidget
      onSelect={onFindingSelect}
      findingsStrength={getFindingsStrength(cr)}
    />
  );
};
